import React from 'react';
import './CharacteristicsOfRelationships.scss'
import HeaderPrint from "../HeaderPrint/HeaderPrint";
import TableCharacteristicsOfRelationships from "./TableCharacteristicsOfRelationships";

const CharacteristicsOfRelationships = ({data}) => {

  try {
    return (
      <>
        {data?.data?.data.map((item, index) => (
          <React.Fragment key={index}>
            <section className='characteristics_of_relationships'>
              <HeaderPrint
                persianTitle={"مشخصات رابطه ها"}
                englishTitle={"Characteristics  of  relationships"}
                color={"#FFDF00"}
              />
              <div className='form_info'>
                <div className='info_box' style={{width: "147px"}}>
                  <div className='box_child'>
                    <span className='iransans'>زیر سیستم :</span>
                    <span className='iransans'>{item.subsystemName}</span>
                  </div>
                  <div className='box_child'>
                    <span className='iransans'>نـام رابطـه :</span>
                    <span className='iransans'>{item.name}</span>
                  </div>
                </div>
                <div className='info_box' style={{width: "147px"}}>
                  <div className='box_child'>
                    <span className='iransans'>کد رابطه :</span>
                    <span className='iransans'>لورم ایپسوم</span>
                  </div>
                  <div className='box_child'>
                    <span className='iransans'>ورژن :</span>
                    <span className='iransans'>{item.version}</span>
                  </div>
                </div>
                <div className='info_box'>
                  <div className='box_child'>
                    <span className='iransans'>تاریخ :</span>
                    <span className='iransans'>{item.date}</span>
                  </div>
                  <div className='box_child'>
                    <span className='iransans'>کاربـر :</span>
                    <span className='iransans'>{item.user}</span>
                  </div>
                </div>
              </div>
              <TableCharacteristicsOfRelationships tableData={item.table}/>
            </section>
            {index < data?.data?.data.length - 1 && (
              <div style={{pageBreakBefore: "always"}}></div>
            )}
          </React.Fragment>
        ))}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default CharacteristicsOfRelationships;